module.exports = __webpack_public_path__ + "05_short_beige.910e887e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_short_beige.png
// module id = hsli
// module chunks = 0